module.exports = __webpack_public_path__ + "video/900_Ares_KSAT45_PersonalizedAttackMethods_2025.e9b26d4a.vtt";